import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';
import Typography from 'antd/lib/typography';

interface CardBaseProps {
    iconNode?: React.ReactNode;
    titleNode?: React.ReactNode;
    ctaNode?: React.ReactNode;
    style?: React.CSSProperties;
}

export const CardBase: React.FC<CardBaseProps> = (props) => {
    return (
        <div
            style={{
                backgroundColor: runwayColors.white,
                border: `1px solid ${antGrey.grey8}`,
                borderRadius: 8,
                boxShadow: 'var(--rw-shadow-card)',
                height: 90,
                padding: 25,
                display: 'flex',
                alignItems: 'center',
                gap: 25,
                ...props.style,
            }}
        >
            {props.iconNode}
            <Typography.Text style={{ fontSize: 28, color: antGrey.grey8, flex: 1 }}>{props.titleNode}</Typography.Text>
            {props.ctaNode}
        </div>
    );
};
